var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeoInside(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 57,
    viewBox: "0 0 48 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1254 0.11736C8.55 1.65772 -0.329696 11.1819 0.588068 22.1379C1.35703 31.098 6.31767 39.993 15.7927 49.4087C18.4963 52.0989 23.4569 56.3077 23.9034 56.3077C24.3994 56.3077 29.2857 52.2941 31.9645 49.6907C40.1745 41.7286 45.3088 33.5278 46.9706 25.7176C47.6403 22.6586 47.5907 18.146 46.8962 15.6511C44.3663 6.73437 35.6106 0.442788 25.1435 0.0305801C23.7794 -0.0345052 21.9687 0.00888502 21.1254 0.11736ZM28.5416 12.093C34.7425 14.7832 36.6276 21.4653 32.5101 26.1949C29.2114 29.9698 23.7298 31.098 19.0419 28.9284C14.5525 26.8675 12.2457 22.42 13.5108 18.2328C14.4037 15.1738 16.9584 12.7873 20.5797 11.5941C21.6462 11.2686 22.4152 11.1819 24.3002 11.247C26.4829 11.2904 26.855 11.3772 28.5416 12.093Z",
    fill: "url(#paint0_linear_1008_873)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1008_873",
    x1: 5.70043,
    y1: 0.730416,
    x2: 51.5193,
    y2: 39.8432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6250FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2D6F3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeoInside);
export default __webpack_public_path__ + "static/media/Seo_inside.dd5d280956b4863457753f735ed65826.svg";
export { ForwardRef as ReactComponent };